"use client";
import React from "react";

interface ClassCardSkeletonProps {
    mobileLayout?: "vertical" | "horizontal";
    count?: number;
}

const SkeletonCard: React.FC<{ mobileLayout: string }> = ({
    mobileLayout,
}) => (
    <div className="w-full">
        <div
            className={`bg-white rounded-xl shadow-lg overflow-hidden w-full flex animate-pulse ${mobileLayout === "horizontal"
                    ? "flex-row sm:flex-col"
                    : "flex-col"
                }`}
        >
            {/* Image skeleton */}
            <div
                className={`relative ${mobileLayout === "horizontal"
                        ? "w-1/3 sm:w-full min-h-[140px]"
                        : "w-full"
                    }`}
            >
                <div
                    className={`w-full bg-gray-200 ${mobileLayout === "horizontal"
                            ? "h-full sm:h-[200px]"
                            : "h-[240px]"
                        }`}
                />
                {/* Badge skeleton */}
                <div className="absolute top-3 left-3 flex gap-1.5">
                    <div className="h-6 w-16 bg-gray-300 rounded-full" />
                    <div className="h-6 w-14 bg-gray-300 rounded-full hidden sm:block" />
                </div>
            </div>

            {/* Content skeleton */}
            <div
                className={`p-4 flex flex-col flex-1 ${mobileLayout === "horizontal" ? "w-2/3 sm:w-full" : "w-full"
                    }`}
            >
                {/* Stats row */}
                <div className="flex items-center gap-4 mb-3">
                    <div className="h-4 w-12 bg-gray-200 rounded" />
                    <div className="h-4 w-20 bg-gray-200 rounded" />
                    <div className="h-4 w-14 bg-gray-200 rounded" />
                </div>

                {/* Title */}
                <div className="h-5 w-3/4 bg-gray-200 rounded mb-2" />

                {/* Description */}
                <div
                    className={`space-y-2 mb-4 ${mobileLayout === "horizontal" ? "hidden sm:block" : ""
                        }`}
                >
                    <div className="h-3 w-full bg-gray-100 rounded" />
                    <div className="h-3 w-5/6 bg-gray-100 rounded" />
                    <div className="h-3 w-2/3 bg-gray-100 rounded" />
                </div>

                {/* Tags */}
                <div className="flex flex-wrap gap-1.5 mb-4">
                    <div className="h-6 w-24 bg-gray-100 rounded-full" />
                    <div className="h-6 w-16 bg-gray-100 rounded-full hidden sm:block" />
                    <div className="h-6 w-20 bg-gray-100 rounded-full hidden sm:block" />
                </div>

                {/* CTA Buttons */}
                <div className="flex gap-2 mt-auto pt-4">
                    <div className="flex-1 h-9 bg-gray-200 rounded-lg" />
                    <div className="flex-1 h-9 bg-gray-100 rounded-lg" />
                </div>
            </div>
        </div>
    </div>
);

const ClassCardSkeleton: React.FC<ClassCardSkeletonProps> = ({
    mobileLayout = "vertical",
    count = 8,
}) => {
    return (
        <>
            {Array.from({ length: count }).map((_, i) => (
                <SkeletonCard key={i} mobileLayout={mobileLayout} />
            ))}
        </>
    );
};

export default ClassCardSkeleton;
